import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { ResetPasswordForm } from "./LoginPage";

export default function ResetPasswordPage() {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-8">
      <Card className="w-full max-w-md bg-white border-gray-200 shadow-lg">
        <CardHeader className="space-y-1">
          <div className="flex items-center gap-3 mb-4">
            <img src="https://customer-assets.emergentagent.com/job_08f655cb-8b91-4c06-80bd-b94d5f4523ca/artifacts/kxmzqj5h_ChatGPT%20Image%2027%20de%20fev.%20de%202026%2C%2001_06_03.png" alt="Kaiso" className="w-10 h-10 rounded-lg" />
            <span className="text-xl font-bold text-gray-800">Kaiso <span className="text-emerald-600">System</span></span>
          </div>
          <CardTitle className="text-2xl font-bold uppercase text-gray-900">Nova Senha</CardTitle>
          <CardDescription className="text-gray-500">Crie uma nova senha para a sua conta</CardDescription>
        </CardHeader>
        <CardContent>
          <ResetPasswordForm />
        </CardContent>
      </Card>
    </div>
  );
}
